module.exports = __webpack_public_path__ + "static/media/Brandon_med.a989c5b7.otf";